import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Backdrop, CircularProgress } from "@mui/material";
import { Button, Col, Popconfirm, Row, Table, TableProps, Typography } from "antd";
import { SorterResult } from "antd/es/table/interface";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { DeleteDomain, GetDomainList, axiosErrorMessages } from "../../../../API/api";
import { useAppRole } from "../../../../API/RoleContext";
import AdminLayout from "../../../../component/AdminLayout";
import SearchBar from "../../../../component/Search";
import { customSortDirections } from "../../../../Utils/utils";
import AddNewDomain from "../components/AddNewDomain";
import axios, { AxiosError } from "axios";

interface DomainItem {
    domainId:number;
    key:number;
    domain:string;
  }
  const DomainSettings = () => {
    const appRole = useAppRole();

    const [isLoading,setIsLoading] = useState<boolean>(false)
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isAddNewDomain,setIsAddNewDomain] = useState<boolean>(false)
    const [editData,setEditData] = useState({})
    const [isAdd,setIsAdd] = useState<boolean>(true)
    const [sortedInfo, setSortedInfo] = useState<SorterResult<DomainItem>>({});
    const [searchText, setSearchText] = useState("");
    const [filteredData, setFilteredData] = useState<DomainItem[]>([]);
    const [domainList,setDomainList]  = useState([])
    const [pagesize,setPageSize] = useState<number>(50)

    useEffect(() => {
      getDomainList()
    },[])
    useEffect(() => {
      if(searchText)
        filterData(searchText)
    },[domainList])
    const getDomainList = async () => {
      try {
        setIsLoading(true)
        const response = await GetDomainList();
        const newData = response.data.map((domain: any, index: number) => ({
          ...domain,
          key: domain.deviceId,
        })

      );
      setDomainList(newData)
      setIsLoading(false)

      } catch (error:any) {
        let errorMsg;
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          errorMsg = axiosErrorMessages(axiosError);
        } else {
          errorMsg = error.message;
        }
        enqueueSnackbar(errorMsg, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
       
        setIsLoading(false)
      }
    }
    const handleSearch = (value:string) =>{
        setCurrentPage(1);
        setSearchText(value);
        filterData(value);
    }
    const handleAddNewSoftware = () => {
        setIsAdd(true)
        setIsAddNewDomain(true)
    }
    const filterData = (searchText: string) => {
        if (!searchText) {
          setFilteredData([]);
        } else {
          const filtered = domainList.filter((item: any) =>
            item.domain.toLowerCase().includes(searchText.toLowerCase())
          );
          setFilteredData(filtered);
        }
      };
    const handleDelete = (rowData:any) =>{
      setIsLoading(true)
      DeleteDomain(rowData)
                  .then((response:any)  =>  {
                    enqueueSnackbar("Deleted Successfully", {
                      variant: "success",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    });

                    setIsLoading(false)
                    getDomainList()
                  })
                  .catch((error:any)  =>  {
                  if(error.response.data.errors.Domain[0])
                    enqueueSnackbar(error.response.data.errors.Domain[0], {
                      variant: "error",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    });
                    else  {
                      let errorMsg;
                      if (axios.isAxiosError(error)) {
                        const axiosError = error as AxiosError;
                        errorMsg = axiosErrorMessages(axiosError);
                      } else {
                        errorMsg = error.message;
                      }
                      enqueueSnackbar(errorMsg, {
                        variant: "error",
                        anchorOrigin: {
                          vertical: "top",
                          horizontal: "right",
                        },
                      });
                    }
                    setIsLoading(false)

                  })



    }
    const edit = (rowData:any) => {setIsAdd(false);setEditData(rowData); setIsAddNewDomain(true)}
    const handleClose = () => {setIsAddNewDomain(false); getDomainList()}
    const handleChange: TableProps<DomainItem>["onChange"] = (
  
        pagination,
        filters,
        sorter
      ) => {
        setSortedInfo(sorter as SorterResult<DomainItem>);
        setCurrentPage(pagination.current || 1);
        setPageSize(pagination.pageSize ?? 50)

      };
    
   
    const columns = [
        {
          title: "No",
          dataIndex: "id",
          key: "id",
          width: "10%",
          render: (text: any, record: any, index: number) =>
            (currentPage - 1) * pagesize + index + 1,
        },
        {
          title: "Domain Name",
          dataIndex: "domain",
          key: "domain",
          width: "40%",
          sorter: (a: any, b: any) => a.domain.localeCompare(b.domain),
          sortOrder: sortedInfo.columnKey === "domain" ? sortedInfo.order : null,
          render: (text: string) =><div>{text}</div>      ,
        },
        ...(appRole
          ? [
        {
          title: "Action",
          dataIndex: "action",
          width: "20%",
    
          render: (_: any, record: any) => {
            return  (
              <>
                {" "}
                <Typography.Link
                  onClick={() => edit(record)}
                >
                  <EditOutlined />
                </Typography.Link>
                <Popconfirm
                  title="Do you want to delete the domain?"
                  onConfirm={() => handleDelete(record.domainId)}
                >
                  <Typography.Link
                    className="delete-btn"
                  >
                    <DeleteOutlined />
                  </Typography.Link>
                </Popconfirm>
              </>
            );
          },
        } 
       ]
        : []),
      ];
    return <>
        <AdminLayout>
        <Backdrop
    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={isLoading}
  >
    <CircularProgress color="inherit" /></Backdrop>
          <div>
            <div className="employee-table-header ">
            <Row gutter={16} style={{ alignItems: "center", margin: "12px 16px 0 16px"}}>
                <Col className="gutter-row" lg={12} sm={24}>
                  <h3 className="bottom-margin-mob" style={{ float: "left" }}>
                    Domain Settings
                  </h3>
                </Col>
                <Col className="gutter-row pm-search-flex" lg={{span: 10, offset: 2}} sm={24} xs={24} style={{ display: "flex"}}>
                  <SearchBar
                    width={"100%"}
                    onSearch={handleSearch}
                    placeholder={"Search Domain"}
                  />
                  {appRole && <Button
                    onClick={handleAddNewSoftware}
                    type="primary"
                    style={{ marginLeft: 10 }}
                    size="small"
                  >
                    Add New
                  </Button>}
                  
                </Col>
              </Row>
            </div>
            <div>
          
           
            </div>
  
              <Table
                sortDirections={customSortDirections}
                scroll={{ x: 1000, y: 450 }}
                className="status-list-admin"
                columns={columns}
                size='small'

                onChange={handleChange}
                pagination={{
                  current: currentPage,
                  showSizeChanger: true,
                  defaultPageSize: 50,
                }}
                rowClassName="editable-row"
                dataSource={searchText ? filteredData : domainList}
              />

              {isAddNewDomain && <AddNewDomain isAdd={isAdd} editData={editData} handleClose={handleClose} />}
          
          </div>
        </AdminLayout>
    </>
}
export default DomainSettings